module.exports = __webpack_public_path__ + "static/media/logo_mi_muro.40d7b243.svg";